<template>
  <div class="sy-nav">
    <van-nav-bar
      :title="$t('routerBase.'+$route.meta.title)"
      left-arrow
      fixed
      :right-text="$t('viewBase.save')"
      @click-left="onClickLeft"
      @click-right="submit"
    />

    <van-cell-group class="vancellgroup">
      <van-cell is-link :title="$t('viewBase.head')" class="align">
        <img v-lazy="info.headUrl" class="avatar" alt="">
        <input type="file" class="file" accept="image/*" @change="fileChange">
      </van-cell>
      <van-field
        readonly
        clickable
        :label="$t('viewBase.relationship')"
        input-align="right"
        is-link
        class="align"
        :value="info.relationShip"
        :placeholder="$t('viewBase.promptrelationship')"
        @click="showPicker = true"
      />
      <van-field v-model="info.name" input-align="right" :label="$t('viewBase.name')" :placeholder="$t('viewBase.entername')" />
      <van-field
        readonly
        clickable
        :label="$t('viewBase.gender')"
        input-align="right"
        is-link
        class="align"
        :value="genderName"
        :placeholder="$t('viewBase.promptgender')"
        @click="showGender = true"
      />
      <van-cell is-link :title="$t('viewBase.dateofbirth')" class="align" @click="showDate=true">
        {{ info.birthdayShow? dateFormat(info.birthdayShow, 'YYYY-MM-DD'):$t('viewBase.select') }}
      </van-cell>
      <van-field
        v-model="info.addr"
        :label="$t('viewBase.detailedaddress')"
        type="textarea"
        :placeholder="$t('viewBase.promptaddress')"
        rows="1"
        input-align="right"
        autosize
      />
      <van-field v-model="info.phone" type="tel" input-align="right" :label="$t('viewBase.mobilenumber')" :placeholder="$t('viewBase.promptmobile')" />
    </van-cell-group>
    <van-popup v-model="showGender" position="bottom">
      <van-picker
        class="van-picker_relative"
        :visible-item-count="3"
        show-toolbar
        :columns="gender"
        value-key="value"
        @cancel="showGender = false"
        @confirm="onConfirmGender"
      />
    </van-popup>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        class="van-picker_relative"
        :visible-item-count="3"
        show-toolbar
        :columns="relationshipList"
        value-key="relationship"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <van-popup v-model="showDate" position="bottom">
      <van-datetime-picker
        v-model="info.birthdayShow"
        class="van-picker_relative"
        show-toolbar
        type="date"
        :max-date="maxdate"
        :min-date="minDate"
        @cancel="showDate = false"
        @confirm="handleMeasureDateConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import { getFamilyRelationshipList, addGroupFamily } from '@/api/family'
import { dateFormat, dateISO, isMobile } from '@/utils/tool'
import { upload } from '@/api/upload.js'
import { getUserGroupId } from '@/utils/auth'
import { setTimeout } from 'timers'

export default {
  data() {
    return {
      dateFormat,
      dateISO,
      value: '',
      showPicker: false,
      relationshipList: [],
      minDate: new Date(1950, 1, 1),
      maxdate: new Date(),
      showDate: false,
      genderName: '',
      gender: [{ id: 'MAN', value: this.$t('viewBase.male') }, { id: 'WOMAN', value: this.$t('viewBase.female') }],
      info: {
        headUrl: '',
        userGroupId: getUserGroupId(),
        relationShip: '',
        name: '',
        birthdayShow: '',
        addr: '',
        gender: '',
        phone: ''
      },
      showNation: false,
      showGender: false
    }
  },
  created() {
    getFamilyRelationshipList().then(response => {
      this.relationshipList = response.data.data
    })
  },
  methods: {
    onConfirm(value) {
      this.info.relationShip = value.relationship
      this.showPicker = false
    },
    onConfirmGender(value) {
      this.info.gender = value.id
      this.genderName = value.value
      this.showGender = false
    },
    onClickLeft() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
        //   Toast('返回')
    },
    // 上传图片
    fileChange(e) {
      if (e.size / 1024 / 1024 > 2) {
        alert('上传图片最大限制2M')
        return false
      }
      var file = e.target.files[0]
      var extension = file.type.split('/')[1]
      upload({
        file,
        extension,
        accountId: this.accountId
      }).then(res => {
        if (res.data.code === 0) {
          this.info.headUrl = res.data.data
        } else {
          this.$toast({
            message: res.Message
          })
        }
      })
    },
    submit: debounce(async function() {
      this.info.birthday = ''
      if (!this.info.relationShip) {
        return this.$toast({
          message: '家人关系未选择',
          duration: 1500
        })
      }
      if (!this.info.name) {
        return this.$toast({
          message: '姓名未填写',
          duration: 1500
        })
      }
      if (!this.info.gender) {
        return this.$toast({
          message: '性别未选择',
          duration: 1500
        })
      }
      if (!this.info.birthdayShow) {
        return this.$toast('出生日期未选择')
      }
      if (!isMobile(this.info.phone)) {
        return this.$toast({
          message: '手机号格式错误',
          duration: 1500
        })
      }
      this.info.birthday = dateISO(`${dateFormat(this.info.birthdayShow, 'YYYY/MM/DD')} 23:59:59`)
      try {
        const { data } = await addGroupFamily(this.info)
        if (data) {
          this.$toast.success('添加成功')
          if (this.$store.state.platform === 'ios') {
            window.webkit.messageHandlers.login.postMessage(data.data)
          } else if (this.$store.state.platform === 'android') {
            const givedata = JSON.stringify(data.data)
            window.Android.login(givedata)
          }
          setTimeout(_ => {
            this.$router.go(-1)
          }, 1500)
        }
      } catch (error) {
        console.log('[login error]:', error)
      }
    }, 500, { leading: true }),
    confirmGender(e) {
      if (e === '男') {
        this.info.gender = 'MAN'
      } else {
        this.info.gender = 'WOMAN'
      }
      this.showGender = false
    },
    handleMeasureDateConfirm() {
      this.showDate = false
    }
  }
}
</script>

<style scoped lang="scss">
  .van-field__control {
    text-align: right;
  }

  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 2px;
    vertical-align: middle;
  }

  .align {
    align-items: center;
    padding-right: 11px;
  }

  .file {
    position: absolute;
    right: -20px;
    width: 80px;
    height: 40px;
    opacity: 0;
    z-index: 100;
  }

  .btn {
    width: 92%;
    margin: 30px 4% 0;
    background: #F99600;
    color: #fff;
  }

  .btn-logout {
    background: #bbb;
    margin: 20px 4%;
  }
  /deep/.van-nav-bar .van-icon {
    color: #F18937;
    vertical-align: middle;
  }
  /deep/.van-nav-bar__text {
    display: inline-block;
    margin: 0 -0.3rem;
    padding: 0 0.3rem;
    color: #F18937!important;
    vertical-align: middle;
  }
</style>

